exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-box[data-v-aaa76d80] {\n  margin-bottom: 20px;\n}\n.pagination[data-v-aaa76d80] {\n  margin-top: 20px;\n  text-align: right;\n}\n", ""]);

// exports
